import React, { useEffect } from 'react';
import Swal from 'sweetalert2';

const QuotaAlert = ({ isOpen, toggle }) => {
    useEffect(() => {
        if (isOpen) {
            Swal.fire({
                title: "LIMIT REACHED.",
                text: "Please contact your administrator.",
                icon: "warning",
                showCancelButton: true,
                //confirmButtonText: "Go to Payment",
                cancelButtonText : "OK",
                showConfirmButton: false
            });
            toggle();
        }
    }, [isOpen, toggle]);

    return null; // No UI is needed since Swal handles the alert display
};

export default QuotaAlert;
